var overArg = require('./_overArg');

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;



/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-persist/~/lodash/_nativeKeys.js
 ** module id = 1101
 ** module chunks = 0
 **/